// packages block
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import React, { useEffect, useState, useRef } from "react";
import {
  Popper,
  Paper,
  Grow,
  ClickAwayListener,
  MenuItem,
  MenuList,
  Avatar,
  Box,
  Typography,
} from "@material-ui/core";
// common block
import "./style.css";
import { FormSelect } from "../../components/form";
import { DetailTabs } from "./components/detailTabs";
import { BackButton } from "../../components/backButton";
import { useStyles } from "../../components/managementTable/styles";
import { AddUserDialog } from "../../components/dialogs/addUserDialog";
// constants, theme, utils and api block
import { setAlert } from "../../redux/reducers/alert";
import { PrimaryBackgroundColor } from "../../styles/colors";
import onlineIcon from "../../../src/assets/gif/online-icon.gif";
import { deleteUser, editUser } from "../../api/users";
import { BASE_IMG, USER_DETAIL_LOGS_DUMMY_DATA } from "../../util/constants";
import { useHistory } from "react-router";
import { WHITE } from "../../theme";
import { setRole } from "../../redux/reducers/role";
import { setStatus } from "../../redux/reducers/status";
import { getUserInfo } from "../../api/auth";

export const UserDetail = (props) => {
  const [, setIsEditText] = useState("");
  const [open, setOpen] = useState(false);
  const [isAddUserDialogVisible, setIsAddUserDialogVisible] = useState(false);
  const [isEditedItem, setIsEditedItem] = useState(null);
  const [schoolData] = useState();
  const anchorRef = useRef(null);
  const dispatch = useDispatch();
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();
  const [currentUser, setCurrentUser] = useState("");

  const { role } = useSelector((state) => state.role);
  const { status } = useSelector((state) => state.status);
  const showErrorAlert = (message) => {
    dispatch(
      setAlert({
        severity: "error",
        message,
        show: true,
      })
    );
  };

  const showSuccessAlert = (message) => {
    dispatch(
      setAlert({
        severity: "success",
        message,
        show: true,
      })
    );
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const handleListKeyDown = (event) => {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  };

  const user = useSelector((state) => state.user);

  const userId =
    props && props.match && props.match.params && props.match.params.userId;
  const userData =
    props &&
    props.location &&
    props.location.state &&
    props.location.state.users;
  const [users] = useState([]);

  const { token } = useSelector((state) => state.user);

  const updateUser = async (data) => {
    try {
      const response = await editUser(data, userId, token);
      if (!response.status)
        showErrorAlert(response?.message || "Error in updating user");
    } catch (err) {
      showErrorAlert(err.message || "Error in updating user");
    }
  };

  const handleChange = (prop) => (event) => {
    if (prop === "role") {
      updateUser({ role: event.target.value });
      dispatch(setRole({ role: event.target.value }));
    }

    if (prop === "status") {
      updateUser({ status: event.target.value === 1 ? 1 : 0 });
      dispatch(setStatus({ status: event.target.value === 1 ? 1 : 0 }));
    }
  };

  const userDelete = async () => {
    try {
      await deleteUser(userId, token);
      showSuccessAlert(t("text_user_deleted_successfully"));
      history.push("/users");
    } catch (err) {
      showErrorAlert(
        err.message || t("text_error_in_deleting_user_please_try_again")
      );
    }
  };

  // const editUserDetail = () => {
  //   setIsAddUserDialogVisible(true);
  // };

  // const closeAddUserDialog = () => {
  //   setIsAddUserDialogVisible(false);
  //   setTimeout(() => {
  //     setIsEditedItem(null);
  //   }, 500);
  // };

  const fetchUser = async () => {
    try {
      const response = await getUserInfo(userId, token);
      if (!response.status) {
        showErrorAlert(
          response?.message || t("text_error_in_fetching_user_detail")
        );
        return;
      }
      setCurrentUser(response?.user);
      setIsEditedItem(response?.user);
      dispatch(setRole({ role: response?.user.role }));
      dispatch(setStatus({ status: response?.user.status === 1 ? 1 : 0 }));
    } catch (err) {
      showErrorAlert(err.message || t("text_error_in_fetching_user_detail"));
    }
  };

  // const editCallback = (text) => {
  //   setIsEditText(text);
  // };

  useEffect(() => {
    if (userId) {
      fetchUser();
    }
  }, [userId]);

  return (
    <>
      <Typography
        variant="h4"
        style={{
          color: "black",
          fontWeight: "bold",
          flex: 1,
          paddingBottom: "10px",
          marginBottom: 20,
        }}
      >
        {t("text_user_details")}
      </Typography>

      <div className="school-management-page user-details-row">
        <div
          style={{
            width: "100%",
            boxShadow: "0px 3px 6px #00000029",
            borderRadius: "31px",
          }}
        >
          <div
            style={{
              padding: "20px 60px 0px 20px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <BackButton />

            <Box
              display="flex"
              flexDirection="row"
              maxWidth="13vw"
              width="100%"
              justifyContent={status ? "space-between" : "flex-end"}
              alignItems="center"
            >
              {status ? (
                <>
                  <img src={onlineIcon} alt="" style={{ width: 20 }} />
                  <Typography
                    component="span"
                    variant="body1"
                    style={{
                      color: WHITE,
                      backgroundColor: "#4cb275",
                      borderRadius: 20,
                      padding: "0.5vh 1.5vw 0.5vh 1.5vw",
                    }}
                  >
                    {t("text_online")}
                  </Typography>
                </>
              ) : (
                <>
                  <Typography
                    component="span"
                    variant="body1"
                    style={{
                      color: WHITE,
                      backgroundColor: "lightgray",
                      borderRadius: 20,
                      padding: "0.5vh 1.5vw 0.5vh 1.5vw",
                    }}
                  >
                    {t("text_offline")}
                  </Typography>
                  &nbsp;
                </>
              )}
              <div
                ref={anchorRef}
                aria-controls={open ? "menu-list-grow" : undefined}
                aria-haspopup="true"
                onClick={handleToggle}
                role="presentation"
                className={classes.actionButton}
              >
                <MoreHorizIcon />
              </div>
            </Box>

            <Popper
              open={open}
              anchorEl={anchorRef.current}
              role={undefined}
              transition
              disablePortal
              style={{ zIndex: "1" }}
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === "bottom" ? "center top" : "center bottom",
                  }}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={handleClose}>
                      <MenuList
                        id="menu-list-grow"
                        onKeyDown={handleListKeyDown}
                      >
                        {/* <MenuItem style={{ color: "black", fontWeight: "bold", fontSize: "12px" }} onClick={editUserDetail}>Edit User</MenuItem> */}
                        <MenuItem
                          style={{
                            color: "black",
                            fontWeight: "bold",
                            fontSize: "12px",
                          }}
                          onClick={userDelete}
                        >
                          {t("text_delete_user")}
                        </MenuItem>
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </div>

          <div
            style={{
              padding: "20px 60px",
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
            }}
          >
            <div style={{ display: "flex" }}>
              <Avatar
                style={{
                  height: 60,
                  width: 60,
                  backgroundColor: PrimaryBackgroundColor,
                }}
                src={currentUser?.file ? `${BASE_IMG}${currentUser.file}` : ""}
              ></Avatar>

              <div style={{ padding: "0px 20px" }}>
                <div
                  style={{
                    color: PrimaryBackgroundColor,
                    fontWeight: "500",
                    textTransform: "capitalize",
                  }}
                >
                  {currentUser?.firstName ? currentUser.firstName : ""}{" "}
                  {currentUser?.lastName ? currentUser.lastName : ""}
                </div>

                <div
                  style={{
                    fontSize: 12,
                    fontWeight: "500",
                    textTransform: "capitalize",
                  }}
                >
                  {currentUser?.role ?? "empty"}
                </div>

                <div style={{ fontSize: 12, fontWeight: "400", color: "gray" }}>
                  Employee ID: {currentUser?.id ? currentUser?.id : "0"}
                </div>
              </div>
            </div>
            <Box display="flex">
              <Box textAlign="center" display="flex" flexDirection="column">
                <Typography variant="body1">{t("text_status")}</Typography>
                <FormSelect
                  disabled={user.role === "readOnly" ? true : false}
                  error={false}
                  list={[
                    {
                      value: 1,
                      label: "Active",
                    },
                    {
                      value: 0,
                      label: "In Active",
                    },
                  ]}
                  value={status === 1 ? 1 : 0}
                  name="status"
                  onChange={handleChange}
                />
              </Box>

              <Box textAlign="center" display="flex" flexDirection="column">
                <Typography variant="body1">{t("text_access")}</Typography>

                <FormSelect
                  disabled={user.role === "readOnly" ? true : false}
                  error={false}
                  list={[
                    {
                      value: "manager",
                      label: "Manager",
                    },
                    {
                      value: "readOnly",
                      label: "Read-Only",
                    },
                    {
                      value: "paymentOnly",
                      label: "Payment Only",
                    },
                  ]}
                  value={role}
                  name="role"
                  onChange={handleChange}
                />
              </Box>
            </Box>
          </div>
          <DetailTabs user={currentUser} />
        </div>

        <div className="transaction-detail-container user-details-col2">
          {/* <div className={"transaction-detail-header"}>
            <div className="activity-log-container">
              Activity Log
            </div>

            {USER_DETAIL_LOGS_DUMMY_DATA.map(({ id, logDetail, logDuration }) => {
              return (
                <Box display="flex" flexDirection="row" justifyContent="space-between" id={id} style={{ padding: "1.5vh 1vw 1.5vh 1vw" }}>
                  <Box display="flex" flexDirection="row">
                    <img src={onlineIcon} alt="" style={{ width: 20 }} />
                    <Typography variant="body1" style={{ paddingLeft: "0.5vw" }} >
                      {logDetail}
                    </Typography>
                  </Box>
                  <Typography variant="body2" style={{ color: "#707070" }} >
                    {logDuration}
                  </Typography>
                </Box>
              )
            })}
          </div> */}

          {/* {
            isAddUserDialogVisible && (
              <AddUserDialog title={"Edit User"}
                schoolData={schoolData}
                handleClose={closeAddUserDialog}
                open={isAddUserDialogVisible}
                editCallback={editCallback}
                isEditedItem={isEditedItem}
                user={user}
                successCallback={
                  () => history.push("/users")
                }
                showCircularProgressBar={true}
              />
            )
          } */}
        </div>
      </div>
    </>
  );
};
